// extracted by mini-css-extract-plugin
export default {"sliderContainer":"Folder_sliderContainer__neQof"};